import {Component, ScrollPane} from 'substance'
import {DWSpellCheckManager} from './services/DWSpellCheckManager'
import {IdfEditorComponent} from './IdfEditorComponent'
import {Event} from '../../../lib/constants/Event'

/**
 * Main IDF editor wrapper component
 *
 * @extends Component
 */
class IdfComponent extends Component {

    constructor(...args) {
        super(...args)

    }

    didMount() {
        const {disableSpellcheck} = this.props
        if (disableSpellcheck === false) {
            this._setupSpellcheck()
        }

        this.context.api.events.on('idf', Event.SETTINGS_CHANGED, (ev) => {
            if (ev.data.key === 'se.infomaker.ximimage.settings.imageDisplayMode') {
                this.rerender();
            }
        })

        // The element div.se-content is created inside Substance scrollable element.
        // We need to attach the click event on that element to catch clicks
        // below the editable surface. This includes the border-bottom set in the css.
        let el = document.querySelector('div.dwc-idf-wrapper div.se-content')
        if (el) {
            el.addEventListener('click', evt => {
                this._onClick(evt)
            })
        }
    }

    dispose() {
        this.context.api.events.off('idf', Event.ARTICLELANGUAGE_CHANGED)
        this.context.api.events.off('idf', Event.SETTINGS_CHANGED)
    }

    getInitialState() {
        return {
            editorSession: this.context.api.editorSession
        }
    }

    render($$) {
        let el
        if (this.state.editorSession === null) {
            el = $$('div')
                .addClass('dwc-idf-wrapper')
        }
        else {
            el = $$('div')
                .addClass('dwc-idf-wrapper')
                .append(
                    $$(ScrollPane, {
                        scrollbarType: "native", // Could also be 'substance'
                        scrollbarPosition: "left",
                        contextMenu: "custom"
                    })
                        .ref("dw-scrollpane")
                        .append(
                            $$(IdfEditorComponent, {
                                editorSession: this.state.editorSession
                            })
                                .addClass('dwc-idf-editor')
                        )
                )
        }

        return el
    }

    /**
     * Handle clicks outside the real editor surface so that we can add
     * an empty paragraph to the end of document if the last node is an object,
     * or set cursor in the correct position if the last element has content.
     *
     * @param evt
     * @returns {boolean}
     * @private
     */
    _onClick(evt) {
        // Ignore clicks not directly on the container editor (ie on text nodes)
        if (evt.target !== evt.currentTarget) {
            return false
        }

        // Don't handle clicks if click is not below the last element in the body
        const editorEl = document.querySelector('div.dwc-idf-editor')
        const offsetTop = editorEl.getClientRects()[0].top
        if (editorEl && editorEl.clientHeight + offsetTop > evt.screenY) {
            return false
        }

        // Find the last node
        const doc = this.context.editorSession.getDocument()
        const nodes = doc.getNodes()['body'].nodes
        const lastNode = nodes.length ? doc.get(nodes[nodes.length - 1]) : null

        if (lastNode && lastNode.isText && lastNode.isText()) {
            // Set selection to text in last node if last node is empty text
            const offset = (lastNode.getText() === '') ? 0 : lastNode.getLength()
            const doc = this.context.editorSession.getDocument()

            this.context.editorSession.setSelection(
                doc.createSelection({
                    type: 'property',
                    containerId: 'body',
                    path: [lastNode.id, 'content'],
                    startOffset: offset,
                    endOffset: offset
                })
            )
        }
        else if (lastNode) {
            // Insert new empty paragraph last in document
            this.context.api.document.insertTextNode({
                mode: 'last'
            })
        }

        return false
    }

    _setupSpellcheck() {
        const {editorSession, api} = this.context

        const spellCheckManager = new DWSpellCheckManager(editorSession, {
            wait: 400,
            // same URL as configured in /server/routes/spellcheck.js
            apiURL: '/api/spellcheck'
        })

        spellCheckManager.runGlobalCheck()

        api.events.on('idf', Event.ARTICLELANGUAGE_CHANGED, () => {
            spellCheckManager.runGlobalCheck()
        })
    }
}

export {IdfComponent}
